import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=713aea8a&scoped=true&"
import script from "./EndScreen.vue?vue&type=script&lang=ts&"
export * from "./EndScreen.vue?vue&type=script&lang=ts&"
import style0 from "./EndScreen.vue?vue&type=style&index=0&id=713aea8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713aea8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
